<form class="f-col blank-form">
    <div class="section-heading">
        <h2 class="h2-heading">FAQs settings <div class="dot">.</div> <span class="optional">Optional</span></h2>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content">

        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Document Title </mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="fill-manually">
                    <div class="f-col">
                        <div class="add-text-input">Upload Document</div>
                    </div>
                    <span>
                        <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
                    </span>
                </div>
            </div>
        </div>


        <div class="inner-action">
            <button mat-button class="button--secondary-small">Cancel</button>
            <button mat-button class="button--primary-small">Save</button>
        </div>
    </div>
</form>
